@use '@lib/assets/styles/main.scss' as *;

.fieldPreviewItem {
  margin-bottom: 24px;
}
